import React from "react";
import ForgotPasswordForm from "./LeftPannel";
import InfoPanel from "../components/RightPannel";
const ForgotPassword = () => {
  return (
    <InfoPanel parent="forgot">
      <ForgotPasswordForm />
    </InfoPanel>
  );
};

export default ForgotPassword;
